import request from '@/utils/http/request'


/* 操作員 */
export async function sysUsers({ sysUserId, realname, pageNumber, pageSize }) {
    return await request.get('/sysUsers', {
        params: {
            sysUserId, realname, pageNumber, pageSize
        }
    });
}

/* 添加操作員 */
export async function sysUsers_insert({ isAdmin, loginUsername, realname, sex, telphone, userNo, state }) {
    return await request.post('/sysUsers', {
        isAdmin, loginUsername, realname, sex, telphone, userNo, state
    });
}

export async function sysUsers_update({ recordId, isAdmin, loginUsername, realname, sex, telphone, userNo, state, resetPass, confirmPwd, defaultPass }) {
    return await request.put(`/sysUsers/${recordId}`, {
        isAdmin, loginUsername, realname, sex, telphone, userNo, state, resetPass, confirmPwd, defaultPass
    });
}


export async function sysUsers_detail(recordId) {
    return await request.get(`/sysUsers/${recordId}`, {});
}


export async function sysUsers_del(recordId) {
    return await request.delete(`/sysUsers/${recordId}`, {});
}


/* 角色管理 */
export async function sysRoles({ roleId, roleName, pageNumber, pageSize }) {
    return await request.get('/sysRoles', {
        params: {
            roleId, roleName, pageNumber, pageSize
        }
    });
}

export async function sysRoles_insert({ roleName, entIdListStr }) {
    return await request.post('/sysRoles', {
        roleName, entIdListStr
    });
}
export async function sysRoles_detail(recordId) {
    return await request.get(`/sysRoles/${recordId}`, {});
}

export async function sysRoles_update({ recordId, roleName, entIdListStr }) {
    return await request.put(`/sysRoles/${recordId}`, {
        roleName, entIdListStr
    });
}
export async function sysRoles_del(recordId) {
    return await request.delete(`/sysRoles/${recordId}`, {});
}

/* 權限 */

export async function sysRoleEntRelas({ roleId, pageNumber, pageSize }) {
    return await request.get('/sysRoleEntRelas', {
        params: {
            roleId, pageNumber, pageSize
        }
    });
}

/* 重置角色的權限相關資訊 */
export async function sysRoleEntRelas_relas(roleId) {
    return await request.post(`/sysRoleEntRelas/relas/${roleId}`, {});
}

export async function sysUserRoleRelas({ userId, pageNumber, pageSize }) {
    return await request.get('/sysUserRoleRelas', {
        params: {
            userId, pageNumber, pageSize
        }
    });
}

/* 更改用戶角色資訊 */
export async function sysUserRoleRelas_relas({ sysUserId, roleIdListStr }) {
    return await request.post(`/sysUserRoleRelas/relas/${sysUserId}`, {
        roleIdListStr
    });
}

export async function sysEnts_showTree(sysType) {
    return await request.get(`/sysEnts/showTree`, {
        params: {
            sysType: sysType || 'MGR'
        }
    });
}

/* 係統配置 */
export async function sysConfigs_stadiumConfig() {
    return await request.get(`/sysConfigs/stadiumConfig`, {});
}

export async function sysConfigs_applicationConfig(data) {
    return await request.put(`/sysConfigs/applicationConfig`, data);
}

export async function sysConfigs_stadiumConfig_insert(configArr) {
    return await request.post(`/sysConfigs/stadiumConfig`, {
        configArr
    });
}